import { render, staticRenderFns } from "./NetworkBundles.vue?vue&type=template&id=11de5210&scoped=true"
import script from "./NetworkBundles.vue?vue&type=script&lang=js"
export * from "./NetworkBundles.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11de5210",
  null
  
)

export default component.exports